export default __webpack_public_path__ + "static/media/skype.2adb272b.svg";